<div class="upload-container">
  <div class="glass-card" [ngSwitch]="step">

    <!-- LOADING STATE -->
    <div *ngSwitchCase="'loading'" class="state-container">
      <div class="spinner"></div>
      <h3>Verifying secure link...</h3>
    </div>

    <!-- INVALID / EXPIRED STATE -->
    <div *ngSwitchCase="'invalid'" class="state-container error-state">
      <div class="icon-circle error">
        <i class="fas fa-times"></i>
      </div>
      <h3>Link Invalid or Expired</h3>
      <p>{{ errorMessage }}</p>
      <p class="help-text">Please contact your driving school for a new secure link.</p>
    </div>

    <!-- REQUEST OTP STATE -->
    <div *ngSwitchCase="'request-otp'" class="state-container request-state">
      <div class="icon-circle info">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h3>Secure Document Upload</h3>
      <p>Hello <strong>{{ firstName }}</strong>,</p>
      <p>To securely upload your documents, we need to verify your identity.</p>
      <p class="phone-info">A verification code will be sent to your phone ending in <strong>{{ maskedPhone }}</strong>.</p>
      
      <button class="modern-btn primary" (click)="requestOtp()" [disabled]="otpRequested">
        <span *ngIf="!otpRequested"><i class="fas fa-paper-plane"></i> Send Verification Code</span>
        <span *ngIf="otpRequested"><i class="fas fa-spinner fa-spin"></i> Sending...</span>
      </button>
    </div>

    <!-- UPLOAD STATE -->
    <div *ngSwitchCase="'upload'" class="state-container upload-state">
      <h3>Upload Your Documents</h3>
      <p class="subtitle">Please provide your verification code and select the file to upload.</p>
      
      <div class="otp-input-container">
        <label>Verification Code (OTP)</label>
        <input type="text" [(ngModel)]="otpCode" placeholder="Enter 6-digit code" maxlength="6" class="modern-input" autocomplete="off" />
        <small>Sent to your phone ending in {{ maskedPhone }}</small>
      </div>

      <div class="drop-zone" 
           [class.dragging]="isDragging" 
           (dragover)="onDragOver($event)" 
           (dragleave)="onDragLeave($event)" 
           (drop)="onDrop($event)"
           (click)="triggerFileInput()">
        
        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png,.pdf" hidden />
        
        <div *ngIf="!selectedFile" class="drop-content">
          <i class="fas fa-cloud-upload-alt upload-icon"></i>
          <h4>Drag & Drop your file here</h4>
          <p>or click to browse</p>
          <span class="file-limits">JPG, PNG, PDF up to 5MB</span>
        </div>

        <div *ngIf="selectedFile" class="selected-file">
          <i class="fas fa-file-alt file-icon"></i>
          <div class="file-details">
            <span class="file-name">{{ selectedFile.name }}</span>
            <span class="file-size">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</span>
          </div>
          <button class="remove-btn" (click)="selectedFile = null; $event.stopPropagation()">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <div *ngIf="isUploading" class="progress-container">
        <div class="progress-bar" [style.width.%]="uploadProgress"></div>
        <span>Uploading securely...</span>
      </div>

      <button class="modern-btn success" [disabled]="!selectedFile || !otpCode || isUploading" (click)="uploadFile()">
        <span *ngIf="!isUploading"><i class="fas fa-check-circle"></i> Secure Upload</span>
        <span *ngIf="isUploading"><i class="fas fa-spinner fa-spin"></i> Processing...</span>
      </button>
    </div>

    <!-- SUCCESS STATE -->
    <div *ngSwitchCase="'success'" class="state-container success-state">
      <div class="icon-circle success">
        <i class="fas fa-check"></i>
      </div>
      <h3>Upload Successful!</h3>
      <p>Your documents have been securely transmitted to the driving school.</p>
      <p class="help-text">You can now close this window safely. Thank you!</p>
    </div>

  </div>
</div>
